import { Component, OnInit, OnDestroy, ElementRef, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampagnesService } from '../../services/requests/campagnes.service';
import { UsersService } from '../../services/requests/users.service';
import { ModalClickOutsideService } from '../../services/modal-click-outside.service';
import * as XLSX from 'xlsx';

declare function showNotif(message: string, type?: string): void;

@Component({
  selector: 'app-suivi',
  templateUrl: './suivi.component.html',
  styleUrls: ['./suivi.component.css']
})
export class SuiviComponent implements OnInit, OnDestroy, AfterViewInit {
  clients: any[] = [];
  smpp: any[] = [];
  campagnes: any[] = [];
  filtered: any[] = [];
  private _searchTerm: string = '';
  get searchTerm(): string {
    return this._searchTerm;
  }
  set searchTerm(value: string) {
    this._searchTerm = value;
    this.applyFilter();
  }
  totalEnvoi = {
    total: 0,
    failed: 0,
    enAttente: 0,
    reallySend: 0,
    envoyer: 0,
    nombreDuplicate: 0,
    nombreTooLong: 0,
    nombreStop: 0,
    nombreReception: 0,
    affected: 0,
    notAffected: 0
  };
  loading = false;
  userId: string | null = '';
  isAdmin = false;
  isSousAdmin = false;
  sortClientAsc = true;
  selectedUserA: string = '';
  selectedUserB: string = '';
  switchText: string = '';
  showSwitchModal: boolean = false;
  isSwitching: boolean = false;
  showModal = false;
  modalConfig: any = {
    title: 'Confirmation',
    confirmText: 'Confirmer',
    cancelText: 'Annuler',
    confirmButtonClass: 'modal-btn-primary',
    icon: 'warning',
    iconColor: 'blue',
    isLoading: false
  };
  pendingAction: () => void = () => {};

  showAddCampaignModal: boolean = false;
  modalClients: any[] = [];
  nouveauMessage = {
    idClient: '',
    messageUnique: '1',
    nomCampagne: '',
    isScheduled: '0',
    schedule: '',
    message: '',
    tooLong: false,
    date: 0,
    fileName: '',
    fileBase64: ''
  };
  selectedClient: string = '';
  upload = false;
  nbImporter = 0;
  isCreating = false;
  error = {
    reference: false,
    message: false,
    destinataire: false,
    schedule: false,
    client: false,
    tooLong: false
  };
  list7Encoding = ['\n', ' ', '@', 'Δ', 'SP', '0', '¡', 'P', '¿', 'p', '£', '_', '!', '1', 'A', 'Q', 'a', 'q', '$', 'Φ', '"', '2', 'B', 'R', 'b', 'r', '¥', 'Γ', '#', '3', 'C', 'S', 'c', 's', 'è', 'Λ', '¤', '4', 'D', 'T', 'd', 't', 'é', 'Ω', '%', '5', 'E', 'U', 'e', 'u', 'ù', 'Π', '&', '6', 'F', 'V', 'f', 'v', 'ì', 'Ψ', '\'', '7', 'G', 'W', 'g', 'w', 'ò', 'Σ', '(', '8', 'H', 'X', 'h', 'x', 'Ç', 'Θ', ')', '9', 'I', 'Y', 'i', 'y', 'LF', 'Ξ', '*', ':', 'J', 'Z', 'j', 'z', 'Ø', '+', ';', 'K', 'Ä', 'k', 'ä', 'ø', 'Æ', ',', '<', 'L', 'Ö', 'l', 'ö', 'CR', 'æ', '-', '=', 'M', 'Ñ', 'm', 'ñ', 'Å', 'ß', '.', '>', 'N', 'Ü', 'n', 'ü', 'å', 'É', '/', '?', 'O', '§', 'o', 'à', '|', '^', '€', '{', '}', '[', ']', '~', '\\'];
  describedText: number[] = [160, 7];

  @ViewChild('switchModalContent', { static: false }) switchModalContent!: ElementRef;
  @ViewChild('addCampaignModalContent', { static: false }) addCampaignModalContent!: ElementRef;

  headerPaddingLeft: number = 280;
  headerPaddingRight: number = 240;
  private resizeHandler?: () => void;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private campagnesService: CampagnesService,
    private usersService: UsersService,
    private modalClickOutsideService: ModalClickOutsideService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loading = true;

    this.isAdmin = localStorage.getItem('isAdmin') === 'true';
    this.isSousAdmin = localStorage.getItem('isSousAdmin') === 'true';
    this.userId = localStorage.getItem('id');

    this.getClients().then(() => {
      this.loadCampagnes().finally(() => {
        this.applyFilter();
        this.loading = false;
      });
    });

    setInterval(() => this.refreshCampagnes(), 20000);
  }

  ngAfterViewInit(): void {
    this.updateModalRegistrations();
    setTimeout(() => {
      this.calculateHeaderPadding();
      this.cdr.detectChanges();
    }, 0);
    this.resizeHandler = () => {
      this.calculateHeaderPadding();
      this.cdr.detectChanges();
    };
    window.addEventListener('resize', this.resizeHandler);
  }

  private calculateHeaderPadding(): void {
    try {
      const sidebar = document.querySelector('.sidebar') as HTMLElement;
      let sidebarWidth = 240;
      
      if (sidebar) {
        const rect = sidebar.getBoundingClientRect();
        sidebarWidth = rect.width || sidebar.offsetWidth || 240;
      } else {
        const rootStyle = getComputedStyle(document.documentElement);
        const sidebarWidthStr = rootStyle.getPropertyValue('--sidebar-width-global') || 
                                rootStyle.getPropertyValue('--sidebar-width') || '240px';
        sidebarWidth = parseInt(sidebarWidthStr.replace('px', ''), 10) || 240;
      }
      
      const padding = sidebarWidth / 2;
      this.headerPaddingLeft = padding;
      this.headerPaddingRight = padding;
    } catch (error) {
      this.headerPaddingLeft = 120;
      this.headerPaddingRight = 120;
    }
  }

  private updateModalRegistrations(): void {
    if (this.switchModalContent) {
      if (this.showSwitchModal) {
        this.modalClickOutsideService.registerModal(this.switchModalContent, () => this.closeSwitchModal());
      } else {
        this.modalClickOutsideService.unregisterModal(this.switchModalContent);
      }
    }
    if (this.addCampaignModalContent) {
      if (this.showAddCampaignModal) {
        this.modalClickOutsideService.registerModal(this.addCampaignModalContent, () => this.closeAddCampaignModal());
      } else {
        this.modalClickOutsideService.unregisterModal(this.addCampaignModalContent);
      }
    }
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    if (this.switchModalContent) {
      this.modalClickOutsideService.unregisterModal(this.switchModalContent);
    }
    if (this.addCampaignModalContent) {
      this.modalClickOutsideService.unregisterModal(this.addCampaignModalContent);
    }
  }

  private updateScroll(): void {
    document.body.style.overflow = (this.showSwitchModal || this.showModal || this.showAddCampaignModal) ? 'hidden' : '';
  }



  getClients(): Promise<void> {
    return new Promise(resolve => {
      this.usersService.getAll().subscribe({
        next: (response: any) => {
          if (response.status) {
            this.clients = response.data?.users || [];
            this.loadSmppClients();
          } else {
            console.warn('⚠️ SP-GetAllUser a répondu sans succès :', response.message);
            showNotif(response.message || '❌ Impossible de charger les utilisateurs', 'error');
          }
          resolve();
        },
        error: (error: any) => {
          console.error('❌ Erreur SP-GetAllUser :', error);
          showNotif('❌ Erreur lors du chargement des utilisateurs', 'error');
          resolve();
        }
      });
    });
  }

  // Méthodes pour la modal d'ajout de campagne
  openAddCampaignModal(): void {
    this.resetCampaignForm();
    this.showAddCampaignModal = true;
    this.updateScroll();
    setTimeout(() => {
      this.updateModalRegistrations();
    }, 0);
    if (this.isAdmin || this.isSousAdmin) {
      this.loadModalClients();
    } else {
      this.nouveauMessage.idClient = this.userId || '';
    }
  }

  loadModalClients(): void {
    this.usersService.getAll().subscribe({
      next: (res: any) => {
        if (res.status && res.data?.users) {
          this.modalClients = res.data.users.filter((u: any) => u.typeAccount === 'client');
        }
      },
      error: (err) => {
        console.error("❌ Erreur loadModalClients() :", err);
      }
    });
  }

  closeAddCampaignModal(): void {
    if (!this.isCreating && !this.upload) {
      this.showAddCampaignModal = false;
      this.resetCampaignForm();
      this.updateScroll();
      this.updateModalRegistrations();
    }
  }

  resetCampaignForm(): void {
    this.nouveauMessage = {
      idClient: this.isAdmin || this.isSousAdmin ? '' : (this.userId || ''),
      messageUnique: '1',
      nomCampagne: '',
      isScheduled: '0',
      schedule: '',
      message: '',
      tooLong: false,
      date: 0,
      fileName: '',
      fileBase64: ''
    };
    this.selectedClient = '';
    this.upload = false;
    this.nbImporter = 0;
    this.error = {
      reference: false,
      message: false,
      destinataire: false,
      schedule: false,
      client: false,
      tooLong: false
    };
    this.describedText = [160, 7];
  }

  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  async fileChange(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.nouveauMessage.fileName = file.name;
    this.nouveauMessage.fileBase64 = '';
    this.nbImporter = 0;
    this.upload = true;

    try {
      const base64 = await this.fileToBase64(file);
      const base64Data = base64.split(',')[1];
      this.nouveauMessage.fileBase64 = base64Data;
      
      await this.compterLignesFichier(file);
      this.upload = false;
    } catch (error) {
      console.error('❌ Erreur traitement fichier:', error);
      this.nouveauMessage.fileName = '';
      this.nouveauMessage.fileBase64 = '';
      this.nbImporter = 0;
      this.upload = false;
      showNotif('❌ Erreur lors du traitement du fichier', 'error');
    }
  }

  async compterLignesFichier(file: File): Promise<void> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target?.result;
          if (data) {
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });
            
            if (Array.isArray(rows)) {
              this.nbImporter = rows.length;
            } else {
              this.nbImporter = 0;
            }
          } else {
            this.nbImporter = 0;
          }
          resolve();
        } catch (error) {
          console.error('❌ Erreur comptage lignes Excel:', error);
          this.nbImporter = 0;
          resolve();
        }
      };
      reader.onerror = () => {
        console.error('❌ Erreur lecture fichier pour comptage');
        this.nbImporter = 0;
        resolve();
      };
      reader.readAsArrayBuffer(file);
    });
  }

  control7Encoding(): void {
    this.describedText = [160, 7];
    for (const char of this.nouveauMessage.message) {
      if (!this.list7Encoding.includes(char)) {
        this.describedText = [70, 16];
        break;
      }
    }
  }

  compterTaille(): number {
    const length = this.nouveauMessage.message.length;
    this.nouveauMessage.tooLong = length > this.describedText[0];
    return length;
  }

  async premiereCreation(): Promise<void> {
    if (this.isAdmin || this.isSousAdmin) {
      this.nouveauMessage.idClient = this.selectedClient;
    }
    
    const m = this.nouveauMessage;
    
    if (m.messageUnique === '0' && m.fileName && !m.fileBase64) {
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    
    if (m.messageUnique === '0') {
      if (!m.fileName || !m.fileBase64) {
        this.error = {
          client: !m.idClient,
          reference: !m.nomCampagne,
          message: false,
          schedule: m.isScheduled === '1' && !m.schedule,
          destinataire: true,
          tooLong: m.tooLong
        };
        return;
      }
    }
    
    this.error = {
      client: !m.idClient,
      reference: !m.nomCampagne,
      message: m.messageUnique === '1' && !m.message,
      schedule: m.isScheduled === '1' && !m.schedule,
      destinataire: false,
      tooLong: m.tooLong
    };

    if (!Object.values(this.error).includes(true)) {
      this.add();
    }
  }

  add(): void {
    const m = this.nouveauMessage;

    const campaignData: any = {
      idClient: m.idClient?.trim() || '',
      nomCampagne: m.nomCampagne?.trim() || '',
      messageUnique: m.messageUnique,
      isScheduled: m.isScheduled,
      schedule: m.isScheduled !== '1' ? new Date(Date.now()).toISOString() : m.schedule,
      date: Date.now(),
      fileName: m.fileName || '',
      fileBase64: m.fileBase64 || ''
    };
    
    if (m.messageUnique === '1') {
      campaignData.message = m.message?.trim() || '';
    } else {
      campaignData.message = 'Message différent par destinataire';
    }

    const champsManquants: string[] = [];
    if (!campaignData.idClient) champsManquants.push('idClient');
    if (!campaignData.nomCampagne) champsManquants.push('nomCampagne');
    if (!campaignData.message) champsManquants.push('message');
    if (!campaignData.fileBase64) champsManquants.push('fileBase64');
    if (!campaignData.fileName) champsManquants.push('fileName');
    if (!campaignData.date) champsManquants.push('date');
    if (campaignData.isScheduled === '1' && !campaignData.schedule) champsManquants.push('schedule');

    if (champsManquants.length > 0) {
      showNotif(`Champs requis manquants : ${champsManquants.join(', ')}`, 'error');
      return;
    }

    this.isCreating = true;

    this.campagnesService.add(campaignData).subscribe({
      next: (response: any) => {
        this.isCreating = false;
        if (response.status) {
          const nbLignes = response.data?.nbLignes || this.nbImporter || 0;
          const messageLignes = nbLignes > 0 ? ` (${nbLignes} lignes détectées)` : '';
          showNotif(`Campagne créée avec succès${messageLignes}`, 'success');
          this.closeAddCampaignModal();
          this.loadCampagnes();
        } else {
          showNotif(response.message || "Erreur lors de la création de la campagne.", 'error');
        }
      },
      error: (error: any) => {
        this.isCreating = false;
        console.error("❌ Erreur API SP-AddCampaign :", error);
        showNotif(error?.error?.message || "Erreur inconnue lors de la création.", 'error');
      }
    });
  }


  loadSmppClients(): void {
    const smppUsers = this.clients.filter(c => c.typeAccount?.toLowerCase() === 'smpp');
    if (smppUsers.length > 0) {
      this.smpp = smppUsers.map(user => ({
        ...user,
        total: 0,
        failed: 0,
        reallySend: 0,
        envoyer: 0,
        enAttente: 0,
        nombreStop: 0,
        nombreTooLong: 0,
        nombreDuplicate: 0,
        nombreReception: 0
      }));
      this.applyFilter();
    }
  }

  loadCampagnes(skipLoading: boolean = false): Promise<void> {
    return new Promise(resolve => {
      this.campagnesService.getAll().subscribe({
        next: async (response: any) => {
          if (!response.status || !response.data) {
            if (!response.status) {
              if (!skipLoading) {
                console.warn('⚠️ SP-GetAllCampaigns a répondu sans succès :', response.message);
                showNotif(response.message || '❌ Impossible de charger les campagnes', 'error');
              }
            }
            await this.loadSmppStats(skipLoading);
            return resolve();
          }

          const campagnes = response.data.campaigns || response.data || [];

          const campagnesIds = new Set<string>();
          
          for (const c of campagnes) {
            campagnesIds.add(c._id);
            let existing = this.campagnes.find(x => x._id === c._id);
            const client = this.clients.find(cli => cli._id === c.idClient);
            const assezCredit = client ? client.assezCredit : true;
            const stats = await this.fetchStats('campagne', c._id);

            if (existing) {
              existing.nomClient = client?.identifiant || '';
              existing.typeClient = client?.typeAccount || '';
              existing.assezCredit = assezCredit;
              existing.total = stats.total || 0;
              existing.failed = stats.failed || 0;
              existing.reallySend = stats.reallySend || 0;
              existing.envoyer = stats.envoyer || 0;
              existing.enAttente = stats.enAttente || 0;
              existing.nombreStop = stats.stop || 0;
              existing.nombreTooLong = stats.tooLong || 0;
              existing.nombreDuplicate = stats.duplicate || 0;
              existing.nombreReception = stats.reception || 0;
              existing.affected = stats.affected || 0;
              existing.notAffected = stats.notAffected || 0;
              existing.isOn = existing.isOn || c.isOn || 'off';
            } else {
              this.campagnes.push({
                ...c,
                nomClient: client?.identifiant || '',
                typeClient: client?.typeAccount || '',
                assezCredit,
                isOn: c.isOn || 'off',
                total: stats.total || 0,
                failed: stats.failed || 0,
                reallySend: stats.reallySend || 0,
                envoyer: stats.envoyer || 0,
                enAttente: stats.enAttente || 0,
                nombreStop: stats.stop || 0,
                nombreTooLong: stats.tooLong || 0,
                nombreDuplicate: stats.duplicate || 0,
                nombreReception: stats.reception || 0,
                affected: stats.affected || 0,
                notAffected: stats.notAffected || 0
              });
            }
          }

          for (let i = this.campagnes.length - 1; i >= 0; i--) {
            if (!campagnesIds.has(this.campagnes[i]._id)) {
              this.campagnes.splice(i, 1);
            }
          }
          
          if (!skipLoading) {
            this.sortByClient();
          }
          await this.loadSmppStats(skipLoading);
          this.recalculateTotals();
          this.applyFilter();
          resolve();
        },
        error: async (error: any) => {
          if (!skipLoading) {
            console.error('❌ Erreur SP-GetAllCampaigns :', error);
            showNotif('❌ Erreur lors du chargement des campagnes', 'error');
          }
          await this.loadSmppStats(skipLoading);
          this.recalculateTotals();
          this.applyFilter();
          resolve();
        }
      });
    });
  }
  
  applyFilter(): void {
    const term = this._searchTerm.toLowerCase().trim();
    const allItems: any[] = [];
    
    this.smpp.forEach(s => {
      allItems.push({ ...s, itemType: 'smpp' });
    });
    
    this.campagnes.forEach(c => {
      allItems.push({ ...c, itemType: 'campagne' });
    });
    
    if (term) {
      this.filtered = allItems.filter(item => {
        if (item.itemType === 'smpp') {
          return item.identifiant?.toLowerCase().includes(term);
        } else {
          return item.nomClient?.toLowerCase().includes(term) || 
                 item.nomCampagne?.toLowerCase().includes(term);
        }
      });
    } else {
      this.filtered = allItems;
    }
    
    this.filtered.sort((a, b) => {
      const aNotDeletable = a.deletable === false ? -1 : 1;
      const bNotDeletable = b.deletable === false ? -1 : 1;
      if (aNotDeletable !== bNotDeletable) {
        return aNotDeletable - bNotDeletable;
      }
      
      const nameA = a.itemType === 'smpp' 
        ? (a.identifiant || '').toLowerCase() 
        : (a.nomClient || '').toLowerCase();
      const nameB = b.itemType === 'smpp' 
        ? (b.identifiant || '').toLowerCase() 
        : (b.nomClient || '').toLowerCase();
      
      return this.sortClientAsc 
        ? nameA.localeCompare(nameB) 
        : nameB.localeCompare(nameA);
    });
    
    this.updateScheduleAlert();
  }

  updateScheduleAlert(): void {
    const needsSchedule = this.totalEnvoi.notAffected < 1000 && this.totalEnvoi.notAffected > 0;
    localStorage.setItem('needsSchedule', needsSchedule ? 'true' : 'false');
  }

  get needsSchedule(): boolean {
    return this.totalEnvoi.notAffected < 1000 && this.totalEnvoi.notAffected > 0;
  }

  refreshCampagnes(): void {
    this.loadCampagnes(true);
  }

  loadSmppStats(skipLoading: boolean = false): Promise<void> {
    return new Promise(async resolve => {
      const smppUsers = this.clients.filter(c => c.typeAccount?.toLowerCase() === 'smpp');
      if (smppUsers.length === 0) {
        return resolve();
      }

      const smppIds = new Set<string>();

      for (const user of smppUsers) {
        smppIds.add(user._id);
        let existing = this.smpp.find(x => x._id === user._id);
        const stats = await this.fetchStats('user', user._id);

        if (existing) {
          existing.total = stats.total || 0;
          existing.failed = stats.failed || 0;
          existing.reallySend = stats.reallySend || 0;
          existing.envoyer = stats.envoyer || 0;
          existing.enAttente = stats.enAttente || 0;
          existing.nombreStop = stats.stop || 0;
          existing.nombreTooLong = stats.tooLong || 0;
          existing.nombreDuplicate = stats.duplicate || 0;
          existing.nombreReception = stats.reception || 0;
          existing.affected = stats.affected || 0;
          existing.notAffected = stats.notAffected || 0;
          existing.isOn = existing.isOn || user.isOn || 'off';
          existing.identifiant = user.identifiant;
          existing.assezCredit = user.assezCredit;
        } else {
          this.smpp.push({
            ...user,
            isOn: user.isOn || 'off',
            total: stats.total || 0,
            failed: stats.failed || 0,
            reallySend: stats.reallySend || 0,
            envoyer: stats.envoyer || 0,
            enAttente: stats.enAttente || 0,
            nombreStop: stats.stop || 0,
            nombreTooLong: stats.tooLong || 0,
            nombreDuplicate: stats.duplicate || 0,
            nombreReception: stats.reception || 0,
            affected: stats.affected || 0,
            notAffected: stats.notAffected || 0
          });
        }
      }

      for (let i = this.smpp.length - 1; i >= 0; i--) {
        if (!smppIds.has(this.smpp[i]._id)) {
          this.smpp.splice(i, 1);
        }
      }
      
      if (!skipLoading) {
        this.sortByClient();
      }
      
      this.updateScheduleAlert();
      resolve();
    });
  }

  private recalculateTotals(): void {
    this.totalEnvoi.total = 0;
    this.totalEnvoi.failed = 0;
    this.totalEnvoi.enAttente = 0;
    this.totalEnvoi.reallySend = 0;
    this.totalEnvoi.envoyer = 0;
    this.totalEnvoi.nombreDuplicate = 0;
    this.totalEnvoi.nombreTooLong = 0;
    this.totalEnvoi.nombreStop = 0;
    this.totalEnvoi.nombreReception = 0;
    this.totalEnvoi.affected = 0;
    this.totalEnvoi.notAffected = 0;

    for (const campagne of this.campagnes) {
      this.totalEnvoi.total += campagne.total || 0;
      this.totalEnvoi.failed += campagne.failed || 0;
      this.totalEnvoi.reallySend += campagne.reallySend || 0;
      this.totalEnvoi.envoyer += campagne.envoyer || 0;
      this.totalEnvoi.enAttente += campagne.enAttente || 0;
      this.totalEnvoi.nombreDuplicate += campagne.nombreDuplicate || 0;
      this.totalEnvoi.nombreTooLong += campagne.nombreTooLong || 0;
      this.totalEnvoi.nombreStop += campagne.nombreStop || 0;
      this.totalEnvoi.nombreReception += campagne.nombreReception || 0;
      this.totalEnvoi.affected += campagne.affected || 0;
      this.totalEnvoi.notAffected += campagne.notAffected || 0;
    }

    for (const smpp of this.smpp) {
      this.totalEnvoi.total += smpp.total || 0;
      this.totalEnvoi.failed += smpp.failed || 0;
      this.totalEnvoi.reallySend += smpp.reallySend || 0;
      this.totalEnvoi.envoyer += smpp.envoyer || 0;
      this.totalEnvoi.enAttente += smpp.enAttente || 0;
      this.totalEnvoi.nombreDuplicate += smpp.nombreDuplicate || 0;
      this.totalEnvoi.nombreTooLong += smpp.nombreTooLong || 0;
      this.totalEnvoi.nombreStop += smpp.nombreStop || 0;
      this.totalEnvoi.nombreReception += smpp.nombreReception || 0;
      this.totalEnvoi.affected += smpp.affected || 0;
      this.totalEnvoi.notAffected += smpp.notAffected || 0;
    }
    
    this.updateScheduleAlert();
  }

  updateIsOn(type: string, id: string, isOn: string): void {
    this.loading = true;

    const request$ = type === 'users'
      ? this.usersService.updateIsOn({ id, isOn })
      : this.campagnesService.updateIsOn({ id, isOn });

    request$.subscribe({
      next: (response: any) => {
        this.loading = false;
        if (response.status) {
          const list = type === 'users' ? this.smpp : this.campagnes;
          const item = list.find(x => x._id === id);
          if (item) item.isOn = isOn;
          this.applyFilter();
          showNotif('État mis à jour avec succès', 'success');
        } else {
          showNotif(response.message || 'Erreur lors de la mise à jour de l\'état', 'error');
        }
      },
      error: (error: any) => {
        this.loading = false;
        console.error('Erreur updateIsOn:', error);
        showNotif(error?.error?.message || 'Erreur lors de la mise à jour de l\'état', 'error');
      }
    });
  }

  getGlobalIsOnState(): 'on' | 'off' | 'mixed' {
    const allItems = [...this.campagnes, ...this.smpp];
    if (allItems.length === 0) return 'off';
    
    const onCount = allItems.filter(item => item.isOn === 'on').length;
    if (onCount === 0) return 'off';
    if (onCount === allItems.length) return 'on';
    return 'mixed';
  }

  toggleAllIsOn(): void {
    const globalState = this.getGlobalIsOnState();
    const newState = (globalState === 'on') ? 'off' : 'on';
    const allItems = [...this.campagnes, ...this.smpp];
    
    if (allItems.length === 0) {
      showNotif('Aucun élément à mettre à jour', 'error');
      return;
    }

    const actionText = newState === 'on' ? 'démarrer' : 'arrêter';
    this.modalConfig = {
      title: `${actionText === 'démarrer' ? 'Démarrer' : 'Arrêter'} toutes les campagnes`,
      message: `Êtes-vous sûr de vouloir <strong>${actionText}</strong> toutes les campagnes et clients SMPP ?`,
      confirmText: actionText === 'démarrer' ? 'Démarrer' : 'Arrêter',
      confirmButtonClass: actionText === 'démarrer' ? 'modal-btn-success' : 'modal-btn-warning',
      icon: 'play_arrow',
      iconColor: actionText === 'démarrer' ? 'green' : 'yellow'
    };
    this.pendingAction = () => this.executeToggleAll(newState);
    this.showModal = true;
    this.updateScroll();
  }

  executeToggleAll(newState: 'on' | 'off'): void {
    this.modalConfig.isLoading = true;
    
    const updates: Promise<any>[] = [];
    
    for (const campagne of this.campagnes) {
      updates.push(
        new Promise(resolve => {
          this.campagnesService.updateIsOn({ id: campagne._id, isOn: newState }).subscribe({
            next: (response: any) => {
              if (response.status) {
                campagne.isOn = newState;
              }
              resolve(response);
            },
            error: (error: any) => {
              console.error(`Erreur updateIsOn campagne ${campagne._id}:`, error);
              resolve({ status: false, error });
            }
          });
        })
      );
    }
    
    for (const smpp of this.smpp) {
      updates.push(
        new Promise(resolve => {
          this.usersService.updateIsOn({ id: smpp._id, isOn: newState }).subscribe({
            next: (response: any) => {
              if (response.status) {
                smpp.isOn = newState;
              }
              resolve(response);
            },
            error: (error: any) => {
              console.error(`Erreur updateIsOn user ${smpp._id}:`, error);
              resolve({ status: false, error });
            }
          });
        })
      );
    }
    
    Promise.all(updates).then(results => {
      this.modalConfig.isLoading = false;
      const successCount = results.filter(r => r.status).length;
      const totalCount = results.length;
      
      if (successCount === totalCount) {
        this.showModal = false;
        this.updateScroll();
        showNotif(`✅ Tous les éléments ont été ${newState === 'on' ? 'démarrés' : 'arrêtés'} avec succès`, 'success');
      } else if (successCount > 0) {
        this.showModal = false;
        this.updateScroll();
        showNotif(`⚠️ ${successCount}/${totalCount} éléments ont été mis à jour`, 'error');
      } else {
        showNotif('❌ Erreur lors de la mise à jour globale', 'error');
      }
    }).catch(error => {
      this.modalConfig.isLoading = false;
      console.error('Erreur lors de la mise à jour globale:', error);
      showNotif('❌ Erreur lors de la mise à jour globale', 'error');
    });
  }

  onModalConfirm(): void {
    this.pendingAction();
  }

  onModalClose(): void {
    if (!this.modalConfig.isLoading) {
      this.showModal = false;
      this.updateScroll();
    }
  }

  supprimer(id: string): void {
    const campagne = this.campagnes.find(c => c._id === id);
    this.modalConfig = {
      title: 'Supprimer la campagne',
      message: `Êtes-vous sûr de vouloir supprimer cette campagne ?<br><strong>${campagne?.nomClient || ''}</strong>`,
      confirmText: 'Supprimer',
      confirmButtonClass: 'modal-btn-delete',
      icon: 'warning',
      iconColor: 'red',
      warningMessage: '<p class="font-medium mb-1">Cette action est irréversible.</p>'
    };
    this.pendingAction = () => this.executeDelete(id);
    this.showModal = true;
    this.updateScroll();
  }

  executeDelete(id: string): void {
    this.modalConfig.isLoading = true;
    this.campagnesService.delete({ id }).subscribe({
      next: (response: any) => {
        this.modalConfig.isLoading = false;
        if (response.status) {
          this.showModal = false;
        this.updateScroll();
          showNotif('🗑️ Campagne supprimée', 'delete');
          this.refreshCampagnes();
        } else {
          showNotif(response.message || "❌ Erreur suppression campagne", 'error');
        }
      },
      error: (error: any) => {
        this.modalConfig.isLoading = false;
        console.error("❌ Erreur supprimer :", error);
        showNotif(error?.error?.message || "❌ Erreur serveur suppression", 'error');
      }
    });
  }

  relancerFailed(idOrType: string, id?: string): void {
    const actualId = id || idOrType;
    const type = id ? idOrType : undefined;
    
    let message = '';
    if (idOrType === 'all') {
      message = 'Êtes-vous sûr de vouloir relancer <strong>TOUS les failed de TOUTES les campagnes</strong> ?';
    } else if (type === 'user') {
      const user = this.smpp.find(s => s._id === actualId);
      message = `Êtes-vous sûr de vouloir relancer <strong>tous les failed</strong> pour l'utilisateur <strong>${user?.identifiant || ''}</strong> ?`;
    } else {
      const campagne = this.campagnes.find(c => c._id === actualId);
      message = `Êtes-vous sûr de vouloir relancer <strong>tous les failed</strong> pour la campagne <strong>${campagne?.nomClient || ''}</strong> ?`;
    }
    
    this.modalConfig = {
      title: 'Relancer les failed',
      message: message,
      confirmText: 'Relancer',
      confirmButtonClass: 'modal-btn-warning',
      icon: 'warning',
      iconColor: 'yellow',
      warningMessage: '<p class="font-medium mb-1">Cette action va remettre en pile d\'envoi tous les SMS failed pour cette sélection.</p>'
    };
    this.pendingAction = () => this.executeRelancerFailed(idOrType, id);
    this.showModal = true;
    this.updateScroll();
  }

  executeRelancerFailed(idOrType: string, id?: string): void {
    this.modalConfig.isLoading = true;
    const actualId = id || idOrType;
    const type = id ? idOrType : undefined;
    
    const data: any = { id: actualId };
    if (type) {
      data.type = type;
    }
    
    this.campagnesService.relancerFailed(data).subscribe({
      next: (response: any) => {
        this.modalConfig.isLoading = false;
        if (response.status) {
          this.showModal = false;
        this.updateScroll();
          showNotif('🔄 Relance réussie', 'success');
          this.refreshCampagnes();
        } else {
          showNotif(response.message || "❌ Erreur relance", 'error');
        }
      },
      error: (error: any) => {
        this.modalConfig.isLoading = false;
        console.error("❌ Erreur relancerFailed :", error);
        showNotif(error?.error?.message || "❌ Erreur serveur relance", 'error');
      }
    });
  }

  relancerDelivered(): void {
    this.modalConfig = {
      title: 'Relancer les délivrés',
      message: 'Êtes-vous sûr de vouloir relancer <strong>tous les SMS délivrés</strong> de cette campagne ?',
      confirmText: 'Relancer',
      confirmButtonClass: 'modal-btn-warning',
      icon: 'warning',
      iconColor: 'yellow',
      warningMessage: '<p class="font-medium mb-1">Cette action va remettre en pile d\'envoi tous les SMS délivrés (status: 1, reallySend: false) de cette campagne.</p>'
    };
    this.pendingAction = () => this.executeRelancerDelivered();
    this.showModal = true;
    this.updateScroll();
  }

  executeRelancerDelivered(): void {
    this.modalConfig.isLoading = true;
    this.campagnesService.relancerDelivered().subscribe({
      next: (response: any) => {
        this.modalConfig.isLoading = false;
        if (response.status) {
          this.showModal = false;
        this.updateScroll();
          showNotif(response.message || '🔄 SMS délivrés remis en pile d\'envoi', 'success');
          this.refreshCampagnes();
        } else {
          showNotif(response.message || '❌ Erreur lors de la relance des délivrés', 'error');
        }
      },
      error: (error: any) => {
        this.modalConfig.isLoading = false;
        console.error('❌ Erreur relancerDelivered :', error);
        showNotif(error?.error?.message || '❌ Erreur serveur lors de la relance des délivrés', 'error');
      }
    });
  }

  relancerTousDelivered(): void {
    this.modalConfig = {
      title: 'Relancer tous les délivrés',
      message: 'Êtes-vous sûr de vouloir relancer <strong>TOUS les délivrés de TOUTES les pilesms</strong> ?',
      confirmText: 'Relancer',
      confirmButtonClass: 'modal-btn-warning',
      icon: 'warning',
      iconColor: 'yellow',
      warningMessage: '<p class="font-medium mb-1">Cette action va remettre en pile d\'envoi tous les SMS délivrés (status: 1, reallySend: false) de toutes les machines.</p>'
    };
    this.pendingAction = () => this.executeRelancerTousDelivered();
    this.showModal = true;
    this.updateScroll();
  }

  executeRelancerTousDelivered(): void {
    this.modalConfig.isLoading = true;
    this.campagnesService.relancerTousDelivered().subscribe({
      next: (response: any) => {
        this.modalConfig.isLoading = false;
        if (response.status) {
          this.showModal = false;
        this.updateScroll();
          showNotif(response.message || '🔄 Tous les SMS délivrés remis en pile d\'envoi', 'success');
          this.refreshCampagnes();
        } else {
          showNotif(response.message || '❌ Erreur lors de la relance de tous les délivrés', 'error');
        }
      },
      error: (error: any) => {
        this.modalConfig.isLoading = false;
        console.error('❌ Erreur relancerTousDelivered :', error);
        showNotif(error?.error?.message || '❌ Erreur serveur lors de la relance de tous les délivrés', 'error');
      }
    });
  }


  supprimerSMPP(idUser: string, number: number): void {
    const user = this.smpp.find(s => s._id === idUser);
    const isAll = number !== 0;
    this.modalConfig = {
      title: 'Supprimer les SMS',
      message: `Êtes-vous sûr de vouloir supprimer ${isAll ? '<strong>les SMS</strong>' : '<strong>tous les SMS EN ATTENTE</strong>'} pour l'utilisateur <strong>${user?.identifiant || ''}</strong> ?`,
      confirmText: 'Supprimer',
      confirmButtonClass: 'modal-btn-delete',
      icon: 'warning',
      iconColor: 'red',
      warningMessage: `<p class="font-medium mb-1">Cette action ${isAll ? 'va supprimer les SMS' : 'va supprimer tous les SMS EN ATTENTE'} pour cet utilisateur.</p><p class="text-red-700">Cette action est irréversible.</p>`
    };
    this.pendingAction = () => this.executeDeleteSMPP(idUser, number);
    this.showModal = true;
    this.updateScroll();
  }

  executeDeleteSMPP(idUser: string, number: number): void {
    this.modalConfig.isLoading = true;
    this.campagnesService.deleteSmppMessage(idUser, number).subscribe({
      next: (response: any) => {
        this.modalConfig.isLoading = false;
        if (response.status) {
          this.showModal = false;
        this.updateScroll();
          showNotif('🗑️ SMS supprimés', 'delete');
          this.refreshCampagnes();
        } else {
          showNotif(response.message || "❌ Erreur suppression SMS", 'error');
        }
      },
      error: (error: any) => {
        this.modalConfig.isLoading = false;
        console.error("❌ Erreur supprimerSMPP :", error);
        showNotif(error?.error?.message || "❌ Erreur serveur suppression SMS", 'error');
      }
    });
  }

  exporter(type: string, id: string, endpoint: string, dossier: string): void {
    this.loading = true;

    const data: any = {
      type: type,
      dossier: dossier
    };

    if (type === 'campagne') {
      data.idCampaign = id;
    } else if (type === 'user') {
      data.id = id;
    }

    this.campagnesService.downloadExportFile(data).subscribe({
      next: (response: any) => {
        this.loading = false;
        if (!response.status || !response.data) {
          showNotif(response.message || '❌ Erreur lors de l\'export du fichier', 'error');
          return;
        }
        window.location.href = response.data.url;
      },
      error: (error: any) => {
        this.loading = false;
        console.error('❌ Erreur export fichier :', error);
        showNotif('❌ Erreur lors de l\'export du fichier', 'error');
      }
    });
  }

  exporterTotal(type: string, id: string): void {
    this.exporter(type, id, 'sms/exportTotal', 'total');
  }
  exporterDuplicate(type: string, id: string): void {
    this.exporter(type, id, 'sms/exportDuplicate', 'duplicate');
  }
  exporterTooLong(type: string, id: string): void {
    this.exporter(type, id, 'sms/exportTooLong', 'tooLong');
  }
  exporterPile(type: string, id: string): void {
    this.exporter(type, id, 'sms/exportPile', 'pile');
  }
  exporterFailed(type: string, id: string): void {
    this.exporter(type, id, 'sms/exportFailed', 'failed');
  }
  exporterStop(type: string, id: string): void {
    this.exporter(type, id, 'sms/exportStop', 'stops');
  }
  exporterReceptions(type: string, id: string): void {
    this.exporter(type, id, 'receptions/export', 'reception');
  }

  private downloadFromBase64(fileBase64: string, fileName: string): void {
    try {
      const binaryString = atob(fileBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('❌ Erreur conversion base64 :', err);
      alert('Erreur lors de la conversion du fichier.');
    }
  }

  formatDateCampagne(campagne: any): string {
    if (!campagne) return '';

    const now = Date.now();
    const scheduleDate = new Date(campagne.schedule);
    const dateTimestamp = Number(campagne.date);

    const formatShort = (timestamp: number): string =>
      new Date(timestamp).toLocaleString('fr-FR', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit'
      });

    if (!isNaN(scheduleDate.getTime()) && scheduleDate.getTime() > now + 60000) {
      return `📅 Prévue : ${formatShort(scheduleDate.getTime())}`;
    }

    if (!isNaN(dateTimestamp)) {
      return `⏱️ Lancée : ${formatShort(dateTimestamp)}`;
    }

    return '';
  }

  private fetchStats(type: 'campagne' | 'user', id: string): Promise<any> {
    return new Promise(resolve => {
      this.campagnesService.getStatsSms({ id, type }).subscribe({
        next: (response: any) => {
          if (!response.status) {
            console.warn(`⚠️ SP-GetSmsApi (${type}) a répondu sans succès :`, response.message);
            return resolve({});
          }
          resolve(response.data || {});
        },
        error: (error: any) => {
          console.error(`❌ Erreur SP-GetSmsApi (${type}) :`, error);
          resolve({});
        }
      });
    });
  }

  toggleSortClient(): void {
    this.sortClientAsc = !this.sortClientAsc;
    this.sortByClient();
    this.applyFilter();
  }

  sortByClient(): void {
    this.campagnes.sort((a, b) => {
      const aNotDeletable = a.deletable === false ? -1 : 1;
      const bNotDeletable = b.deletable === false ? -1 : 1;
      if (aNotDeletable !== bNotDeletable) {
        return aNotDeletable - bNotDeletable;
      }
      
      const nameA = (a.nomClient || '').toLowerCase();
      const nameB = (b.nomClient || '').toLowerCase();
      return this.sortClientAsc 
        ? nameA.localeCompare(nameB) 
        : nameB.localeCompare(nameA);
    });

    this.smpp.sort((a, b) => {
      const aNotDeletable = a.deletable === false ? -1 : 1;
      const bNotDeletable = b.deletable === false ? -1 : 1;
      if (aNotDeletable !== bNotDeletable) {
        return aNotDeletable - bNotDeletable;
      }
      
      const nameA = (a.identifiant || '').toLowerCase();
      const nameB = (b.identifiant || '').toLowerCase();
      return this.sortClientAsc 
        ? nameA.localeCompare(nameB) 
        : nameB.localeCompare(nameA);
    });
  }

  getAvailableUsersA(): any[] {
    return this.smpp.filter(s => s._id !== this.selectedUserB);
  }

  getAvailableUsersB(): any[] {
    return this.smpp.filter(s => s._id !== this.selectedUserA);
  }

  openSwitchModal(): void {
    this.showSwitchModal = true;
    this.updateScroll();
    setTimeout(() => {
      this.updateModalRegistrations();
    }, 0);
  }

  closeSwitchModal(): void {
    if (!this.isSwitching) {
      this.showSwitchModal = false;
      this.selectedUserA = '';
      this.selectedUserB = '';
      this.switchText = '';
      this.updateScroll();
    }
  }

  switchCampaignSmpp(): void {
    if (!this.selectedUserA || !this.selectedUserB) {
      showNotif('Veuillez sélectionner les deux clients API', 'error');
      return;
    }

    if (this.selectedUserA === this.selectedUserB) {
      showNotif('Les deux clients doivent être différents', 'error');
      return;
    }

    const userA = this.smpp.find(s => s._id === this.selectedUserA);
    const userB = this.smpp.find(s => s._id === this.selectedUserB);
    const userAName = userA?.identifiant || 'Client A';
    const userBName = userB?.identifiant || 'Client B';

    this.isSwitching = true;
    this.loading = true;
    this.campagnesService.switchCampaignSmpp({
      idUserA: this.selectedUserA,
      idUserB: this.selectedUserB,
      text: this.switchText || undefined
    }).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.isSwitching = false;
        if (response.status) {
          showNotif(`SMS transférés avec succès de "${userAName}" vers "${userBName}"`, 'success');
          this.closeSwitchModal();
          this.refreshCampagnes();
        } else {
          showNotif(response.message || 'Erreur lors du transfert', 'error');
        }
      },
      error: (error: any) => {
        this.loading = false;
        this.isSwitching = false;
        console.error('❌ Erreur switchCampaignSmpp :', error);
        showNotif('Erreur lors du transfert des SMS', 'error');
      }
    });
  }

  copyRefCampagne(text: string, event: Event): void {
    event.stopPropagation();
    
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        showNotif('📋 ID copié dans le presse-papiers', 'success');
      }).catch(() => {
        this.fallbackCopyToClipboard(text);
      });
    } else {
      this.fallbackCopyToClipboard(text);
    }
  }

  private fallbackCopyToClipboard(text: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      showNotif('📋 ID copié dans le presse-papiers', 'success');
    } catch (err) {
      showNotif('❌ Impossible de copier l\'ID', 'error');
    }
    
    document.body.removeChild(textArea);
  }

  getPercentage(item: any): number {
    if (!item || !item.total || item.total === 0) {
      return 0;
    }
    const total = item.total;
    const reallySend = item.reallySend || 0;
    const failed = item.failed || 0;
    const percentage = ((reallySend + failed) / total) * 100;
    return Math.round(percentage);
  }

  getFailedPercentage(item: any): number {
    if (!item) {
      return 0;
    }
    const reallySend = item.reallySend || 0;
    const failed = item.failed || 0;
    const total = reallySend + failed;
    
    if (total === 0) {
      return 0;
    }
    
    const percentage = (failed / total) * 100;
    return Math.round(percentage);
  }

  getTotalPercentage(): number {
    let totalSum = 0;
    let processedSum = 0;

    // Parcourir toutes les campagnes
    for (const campagne of this.campagnes) {
      const total = campagne.total || 0;
      const reallySend = campagne.reallySend || 0;
      const failed = campagne.failed || 0;
      
      totalSum += total;
      processedSum += (reallySend + failed);
    }

    for (const smpp of this.smpp) {
      const total = smpp.total || 0;
      const reallySend = smpp.reallySend || 0;
      const failed = smpp.failed || 0;
      
      totalSum += total;
      processedSum += (reallySend + failed);
    }

    if (totalSum === 0) {
      return 0;
    }

    const percentage = (processedSum / totalSum) * 100;
    return Math.round(percentage);
  }

  getTotalFailedPercentage(): number {
    let processedSum = 0;
    let failedSum = 0;

    for (const campagne of this.campagnes) {
      const reallySend = campagne.reallySend || 0;
      const failed = campagne.failed || 0;
      
      processedSum += (reallySend + failed);
      failedSum += failed;
    }

    for (const smpp of this.smpp) {
      const reallySend = smpp.reallySend || 0;
      const failed = smpp.failed || 0;
      
      processedSum += (reallySend + failed);
      failedSum += failed;
    }

    if (processedSum === 0) {
      return 0;
    }

    const percentage = (failedSum / processedSum) * 100;
    return Math.round(percentage);
  }

  trackByCampagneId(index: number, item: any): string {
    return item?._id || index;
  }

  trackBySmppId(index: number, item: any): string {
    return item?._id || index;
  }
}
